import { Typography } from "@/design-system/Atoms";
import { useInViewOnce } from "@/hooks/useInViewOnce";

interface BenefitCardProps {
  image: string;
  title: string;
  description: string;
  className?: string;
  isOralMed?: boolean;
}

const BenefitCard = ({
  image,
  title,
  description,
  className,
  isOralMed = false,
}: BenefitCardProps) => {
  const { ref, isVisible } = useInViewOnce<HTMLDivElement>();

  return (
    <div className="">
      <a href="#0" className="block">

        <div
          ref={ref}
          className={`grow overflow-hidden inline-block rounded-[20px] w-full h-full transition-opacity duration-700 ${isVisible ? "animate-fade-in-up opacity-100" : "opacity-0"} ${className}`}
        >
          <img
            src={image}
            alt={title}
            className="w-full object-cover rounded-[20px] transition-transform duration-400 ease-in-out hover:scale-[1.05]"
          />
        </div>
        <div className="pt-[25px]">
          {isOralMed ? (
            <Typography as="h3" variant="benifitH3" className="mt-4 mb-2">
              {title}
            </Typography>
          ) : (
            <Typography as="h3" variant="benifitH3" className="my-4">
              {title}
            </Typography>
          )}
          <Typography
            as="p"
            variant="cardDescription"
            className="text-[#3b4151]"
          >
            {description}
          </Typography>
        </div>
      </a>
    </div>
  );
};

export default BenefitCard;
